import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import {
  ArrayInput,
  Button,
  SimpleFormIterator,
  TextInput,
  required,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { SupervisorIteratorItem } from "../../ApprovedCandidacies/Enroll/TopicAndSupervisorsSection";

const SupervisorsEditDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record?.id) return null;

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.updateDoctorantSupervisors(record.id),
      {
        supervisorEmployeeIds: (data.supervisors ?? []).map(s => s?.employeeId).filter(Boolean),
        orderNumber: data.orderNumber,
        orderDate: data.orderDate,
      },
      "PUT",
    );
    notify("Научните ръководители са обновени успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на научни ръководители"
      saveTitle="Запази"
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={{
        supervisors: (record.supervisors ?? []).map(s => ({ employeeId: s.employeeId })),
      }}
      triggerButton={
        <Button
          label="Редактирай"
          variant="outlined"
          size="small"
          startIcon={<EditIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayInput
            source="supervisors"
            label="Научни ръководители"
            validate={required("Задължително")}
          >
            <SimpleFormIterator inline={false} disableClear>
              <SupervisorIteratorItem />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="orderNumber"
            label="Номер на заповед"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="orderDate"
            label="Дата на заповед"
            validate={required("Задължително")}
            noTime
            fullWidth
            required
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default SupervisorsEditDialog;
